import { Card } from '@navi/web-ui/lib/primitives';
import styles from '../index.module.scss';
import { useSelector } from 'react-redux';
import { NAVI_AGENCY_CODE } from '@cp/src/pages/AllAgents/AgentForm/constants/constants';
import { RootState } from '@cp/src/store';
import AddressFeedbackDetailImage from './AddressFeedbackDetailImage';
import { getAnswerText, getQuestionText } from './utils';
import { IAnswerView, IFeedback, OPTION_TAG } from '../interfaces';
import cx from 'classnames';
import FeedbackQuestionsRenderer from './FeedbackQuestionsRenderer';
import { useMemo } from 'react';

const FeedbackItemBody = (props: { feedbackDetails: IFeedback }) => {
  const { feedbackDetails } = props;
  const { answerViews: answerList = [], agentName, agentNumber } = feedbackDetails || {};
  const { imageAnswerList, textAnswerList } = useMemo(() => {
    const imageAnswerList: IAnswerView[] = [];
    const textAnswerList: IAnswerView[] = [];
    answerList?.forEach(answer => {
      if (answer?.questionTag === OPTION_TAG.IMAGE_UPLOAD) {
        imageAnswerList.push(answer);
      } else {
        textAnswerList.push(answer);
      }
    });
    return { imageAnswerList, textAnswerList };
  }, [answerList]);

  const user = useSelector((state: RootState) => state.common.userData);

  return (
    <Card className={styles.feedbackDetailsCard}>
      {imageAnswerList?.map((image: IAnswerView) => (
        <AddressFeedbackDetailImage key={image?.referenceId} image={image} />
      ))}

      {textAnswerList?.map((answerItem: IAnswerView) => (
        <FeedbackQuestionsRenderer
          questionText={getQuestionText(answerItem)}
          answerText={getAnswerText(answerItem)}
          key={answerItem?.referenceId}
        />
      ))}
      {agentName ? (
        <FeedbackQuestionsRenderer questionText={'Agent Name'} answerText={agentName} />
      ) : null}
      {agentNumber ? (
        <FeedbackQuestionsRenderer questionText={'Agent Number'} answerText={agentNumber} />
      ) : null}
    </Card>
  );
};

export default FeedbackItemBody;
